/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  createDistributor : ' https://us-central1-techtone-admin.cloudfunctions.net/createDistributor',
  createretailer : ' https://us-central1-techtone-admin.cloudfunctions.net/createRetailer',
  firebaseConfig : {
    apiKey: 'AIzaSyAwICujgYXB8SmdTtTECr-Fz9Jwt4qnc_A',
    authDomain: 'techtone-admin.firebaseapp.com',
    databaseURL: 'https://techtone-admin.firebaseio.com',
    projectId: 'techtone-admin',
    storageBucket: 'techtone-admin.appspot.com',
    messagingSenderId: '1017101107979',
    appId: '1:1017101107979:web:47703cd8f1d364797b980e',
    measurementId: 'G-KNGTS79FCV',
  },
};
